export default __webpack_public_path__ + "static/media/social_icon_haiti.b4e66ac6.png";